import FormDataSource from './FormDataSource.js';
import FormDataSourceGroup from './FormDataSourceGroup';
import {CurrentGroupSetStore,CurrentGroupGetStore} from '../stores/FocusStore';
import ToolBarUtil from '../utils/ToolBarUtil';
import QueryUtil from '../utils/QueryUtil';
import FormDataSourceGroupLinkType from './FormDataSourceGroupLinkType';
import ArgCallerType from '../forms/sys/ArgCallerType';
import FocusActions from '../actions/FocusActions';
import UtilActions from '../actions/UtilActions';

export default class FormDataSources
{
	groups = {};

	groupsInited = {};

	static setUserDefaultExportList(setting,key)
	{
		let userExportList = window.userExportList?window.userExportList:window.parent.window.userExportList;
		if(userExportList)
		{
			userExportList[key] = setting;
			if(setting == null)
			{
				delete userExportList[key];
			}
		}
	}

	static getUserDefaultExportList(key)
	{
		let userExportList = window.userExportList?window.userExportList:window.parent.window.userExportList;
		if(!userExportList)return;
		return userExportList[key];
	}

	static updateUserDefaultExportListDupName(fileName,key,exportSetting)
	{
		let userExportList = window.userExportList?window.userExportList:window.parent.window.userExportList;
		if(!userExportList)return;
		var defaultSetting = userExportList[key];
		var doc = (new DOMParser()).parseFromString(defaultSetting,"application/xml");
		var	mainMsg=doc.getElementsByTagName("nodes")[0];
		if(defaultSetting && mainMsg.attributes.fileName.nodeValue==fileName)
		{
			userExportList[key] = exportSetting;
		}
	}
	static userExportList = {};

	currentGroup = null;

    static isLinkType(value)
    {
		if(value == "Passive" || value == "Delayed" || value == "Active" || value == "")
			return true;
		return false;
    }


    constructor(xml,formModule,forLookup = false)
    {
    	this.xml = xml;
    	this.forLookup = forLookup;
    	this.formModule = formModule;
    
    	this.firstGroup = null;
    	var ds = {};this.sources = ds;
		var datasources = this.xml.DataSources;
		if(datasources.length == 0)
			return;
		this.sortOnClient = false;
		if(this.xml.Properties.SortOnClient)
			this.sortOnClient = !(this.xml.Properties.SortOnClient.Value == "false");
		var firstSourceName = datasources[0].name;
		for(var i in datasources)
		{
			let item = datasources[i];
			var _mid = formModule.classAlias == "FormModuleLookup"?"FormLookup":window.menuItemId;
			var _fid = formModule.classAlias == "FormModuleLookup"?formModule.props.formId:window.formId;
			ds[item.name] = new FormDataSource(item,_mid,_fid,forLookup);
		}
		
		for(var fdsName in ds)
		{
			let fds = ds[fdsName];
			let sourceValue = fds.xml.Properties.JoinSource.Value;
			if(sourceValue!="")
				fds.joinSource = ds[sourceValue];
		}
		this.sources = ds;
		
		for(var dsName in ds)
		{
			let fds = ds[dsName];
			if(FormDataSources.isLinkType(fds.joinType))
			{
				let group = new FormDataSourceGroup(dsName,fds,this,forLookup);
				group.sortOnClient = this.sortOnClient;
				fds.group = group;
				this.groups[dsName] = group;
				this.groupsInited[dsName] = false;
			}
		}
		
		var flag = true;
		var outFlag = true;
		while(outFlag)
		{
			flag = true;
			for(var fdsName in ds)
			{
				var fds = ds[fdsName];
				if(fds.group==null)
				{
					if(fds.joinSource.group!=null)
					{
						fds.group = fds.joinSource.group;
						fds.group.sources.push(fds);
					}
					else
					{
						flag = false;
					}
				}
			}
			if(flag)
				outFlag = false;
		}
		
		for(var groupName in this.groups)
		{
			let group = this.groups[groupName];
			if(group.mainSource.joinSource!=null)
			{
				group.linkGroup = group.mainSource.joinSource.group;
			}
			else
			{
				group.linkGroup = null;
				if(!this.forLookup && window.hasOwnProperty("argCaller") && group.allowExternalJoin)
			    {
			        let argCaller = window.argCaller;
			        if(argCaller.type == "FormModule" && argCaller.joinGroupAlias != "")
			        {
			        	group.externalJoinGroupAlias = argCaller.joinGroupAlias;
			        	var _parentWindow = window.parent.window;
			        	group.linkGroup = _parentWindow.getJoinGroupObject(group.externalJoinGroupAlias,argCaller.calleruuId)
			        }
			    }
			}
		}
		console.log(this.groups);
		if(firstSourceName!=null)
		{
			this.firstGroup = this.sources[firstSourceName].group;
			if(this.firstGroup && this.formModule.classAlias == "FormModule" && window.argCaller && window.argCaller.enterMainForm)
			{
				this.firstGroup.flag_enterMainForm = true;
			}
		}
			
		this.currentGroup = null;

		this.unsubscribeCurrentGroupSetStore = CurrentGroupSetStore.listen(this.onCurrentGroupSet.bind(this));
		this.unsubscribeCurrentGroupGetStore = CurrentGroupGetStore.listen(this.onCurrentGroupGet.bind(this));
	}

	onCurrentGroupGet(result)
	{
		if(result)
			result.currentGroup = this.currentGroup;
	}

	componentWillUnmount()
	{
		this.unsubscribeCurrentGroupSetStore();
		for(let key in this.groups)
		{
			let group = this.groups[key];
			group.componentWillUnmount();
		}
	}

	onCurrentGroupSet(groupAlias,formId,focusedId)
	{
		/*TODO 本来想法是 Warn的弹出 销毁以后 保持弹出前的状态 不重复执行切换Group的动作
		但是该想法在稍微复杂点的场景下不适用 比如 点击按钮 先弹出了dialog 此时currentGroup可能为空了 再回来 还是要执行currentGroup的切换的
		也就是说 由于焦点情况比较复杂 而需求又得保证焦点实际位置与内存currentGroup变量的一致性
		所以只能接受重复设置
		if(window.testWarnShowedToRemove == true)
		{
			window.testWarnShowedToRemove = false;
			return;
		}*/
		if(this.formModule.classAlias == "FormLookup")
			return;
		if(this.formModule.formId != formId)
			return;

		if(this.currentGroup != null)
		{
			var targetGroup;
			if(groupAlias == null || groupAlias == "" || groupAlias == undefined)
			{
				targetGroup = null;
			}
			else
			{
				targetGroup = this.groups[groupAlias];
			}

			//console.log("targetGroup:"+targetGroup.groupAlias + "--currentGroup:" + this.currentGroup.groupAlias)

			if(this.currentGroup != targetGroup)
			{
				this.currentGroup.onRecordAutoSave(this.currentGroup.groupAlias);
				if(window.rowChangeAutoSaveFail)
					return;
				this.currentGroup = targetGroup;
				//存在两种情况需要强制更新toolbar 1.画面刚打开 时序上为先触发currentRecordChanged 再定位焦点 从而设置currentGroup 由于currentRecordChanged更新toolbar时currentGroup为空 所以不更新toolbar
				//2.从某个控件切换到另外一个控件 记录并未自动保存并且更新 需要强制更新toolbar
				//从代码上看Flex版执行了currentRecordChanged所有内容 但是理论上应该是不对的 所以先只执行更新toolbar的操作
				this.updateToolBarByCurrentGroup();
				if(this.currentGroup)this.currentGroup.activeAttachment();
				if(this.currentGroup && this.groupsInited[this.currentGroup.groupAlias] == false)
				{
					this.groupsInited[this.currentGroup.groupAlias] = true;
					//this.currentGroup.activeCurrentRecord(false,focusedId);
					this.currentGroup.activeRecordRemote();
					
				}
					
			}
		}
		else
		{
			if(groupAlias != null && groupAlias != "" && groupAlias != undefined)
			{
				this.currentGroup = this.groups[groupAlias];
				this.updateToolBarByCurrentGroup();
				if(this.currentGroup && this.groupsInited[groupAlias] == false)
				{
					this.groupsInited[groupAlias] = true;
					this.currentGroup.activeCurrentRecord(false);
				}
			}
		}
		FocusActions.notifyDataGridCurrentGroup(this.currentGroup?this.currentGroup.groupAlias:null,this.formModule.instanceUUId);
	}	

	updateToolBarByCurrentGroup()
	{
		if(this.currentGroup == null)
		{
			var _parentWindow = window.parent.window;
		    if(_parentWindow)
		    {
		    	//window.toolBarObject.RecordNew = true;
		    	//window.toolBarObject.RecordSave = false;
		    	ToolBarUtil.setObjectGroupNull(window.toolBarObject);
				if(window.isDataSetView == true){
					if(window.toolBarObject){
						window.toolBarObject.Export =true;
					  }
				}
				_parentWindow.setToolBar(window.toolBarObject);
				UtilActions.updateInnerToolBar(window.toolBarObject);
		    }
		}
		else
		{
			this.currentGroup.activeToolBarByRecord();
		}
	}
    

    updateLinkGroup(sourceGroup,formModuleInstanceuuId,delay = true,updateRelatedPart=false)
	{
		//此处原因与Timer本身无关 是变量作用域与程序逻辑的问题
		var cache = [];
		var _baseRecord = sourceGroup.currentRecord;
		var _formName = this.formModule.formName;
		//alert(_formName+"1");
		for(var key in this.groups)
		{
			var group = this.groups[key];
        	var externalJoin = window.hasOwnProperty("argCaller") && window.argCaller.type == ArgCallerType.FormModule && formModuleInstanceuuId == window.argCaller.calleruuId && group.externalJoinGroupAlias == sourceGroup.groupAlias;
			if(group!=sourceGroup && (group.linkGroup==sourceGroup || externalJoin)
				&& (group.linkType==FormDataSourceGroupLinkType.DELAYED || group.linkType==FormDataSourceGroupLinkType.ACTIVE || group.linkType == FormDataSourceGroupLinkType.PASSIVE))
			{ 
				
				var _group = group;

				//TODO 存在某些情况 新增完表头马上新增明细 如果此处延迟 会造成后台错误  所以如果比如保存完之后 此处activeRecord应该即时更新
				if(!delay)
				{
					this.callLinkGroup(_group, _baseRecord, sourceGroup,updateRelatedPart);
				}
				else if(_group.linkType==FormDataSourceGroupLinkType.DELAYED)
				{	
					//alert(_formName+"2");
					cache.push(_group.groupAlias);
				}
				else if(_group.linkType==FormDataSourceGroupLinkType.ACTIVE || _group.linkType == FormDataSourceGroupLinkType.PASSIVE)
				{
					this.callLinkGroup(_group, _baseRecord, sourceGroup,updateRelatedPart);
				}
				//group.linkType=="" || "Passive" 不做自动变更
			}
		}


		if(cache.length > 0)
		{
			var _callLinkGroup = this.callLinkGroup.bind(this);
			var _groups = this.groups;
			
			var timerid = setTimeout(function(){
				clearTimeout(timerid);
				for(var i=0;i<cache.length;i++)
				{
					var alias = cache[i];
					//GongqiAlert.show(String(cache.length));
					//alert(alias+"  "+_formName);
					_callLinkGroup(_groups[alias], _baseRecord, sourceGroup,updateRelatedPart);
				}
				
			},600);
		}	
	}

	

	callLinkGroup(group, baseRecord,sourceGroup,updateRelatedPart = false)
	{
		if(!group || !sourceGroup)
			return;
		
		var mainAlias = sourceGroup.mainSource.alias;
		if(sourceGroup.currentRecord!=baseRecord)
		{
			//alert("不相等");
			return;
		}
		
		
		if(group.formQuery)
		{
			var joinQueryTable = QueryUtil.getQueryTableByName(group.formQuery,"Auto_JoinParent");
			if(joinQueryTable)
			{
				var list = QueryUtil.getQueryRelationItemByProperty(joinQueryTable,"dataField");
				var s = "";
				for(let i in list)
				{
					var item = list[i];
					if(!baseRecord)
					{
						item.Properties.FieldValue.V = "#null#";
					}
					else
					{
						let _key = mainAlias + "." + item.dataField;
						if(!baseRecord.hasOwnProperty(_key))
						{
							s = "";
						}
						else
						{
							s = baseRecord[_key];
						}
						//TODO 如果是数字的 则认为肯定不是空
						if(typeof(s) == "number" || s!="")
							item.Properties.FieldValue.V = s;
						else
							item.Properties.FieldValue.V = "#null#"
						
					}
				}
				let formQueryCopy = JSON.parse(JSON.stringify(group.formQuery));
				group.reSetCurrentQuery(formQueryCopy);
				//如Passive 只更新query 不做实际查询
				if(updateRelatedPart)
					return;
				if(group.linkType != FormDataSourceGroupLinkType.PASSIVE)
					group.doLinkActive();
			}
		}
	}

}
  


// WEBPACK FOOTER //
// ./src/datasource/FormDataSources.js